import { getTopPx, getHeightPx } from '../model/calendarConstants'

const BREAK_DURATION = 30
const BREAK_COLOR = '#94A3B8'

interface Props {
  startTimeIso: string
  overrideTopPx?: number
  left?: string
  zIndex?: number
  interactive?: boolean
  isDragging?: boolean
  onPointerDown?: (e: React.PointerEvent<HTMLDivElement>) => void
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

export const WorkerBreakBlock = ({
  startTimeIso, overrideTopPx, left, zIndex,
  interactive, isDragging, onPointerDown, onClick,
}: Props) => {
  const top = overrideTopPx ?? getTopPx(startTimeIso)
  const height = Math.max(getHeightPx(BREAK_DURATION), 14)

  return (
    <div
      data-block
      className={`absolute right-0.5 flex items-center px-1 text-white text-[12px] font-semibold rounded overflow-hidden ${
        interactive
          ? `cursor-grab active:cursor-grabbing ${isDragging ? 'opacity-100' : 'opacity-80 hover:opacity-100'}`
          : ''
      }`}
      style={{
        top, height, left: left ?? '2px', zIndex: zIndex ?? 10,
        backgroundColor: BREAK_COLOR,
        touchAction: interactive ? 'none' : undefined,
        transition: isDragging ? undefined : 'top 150ms ease',
      }}
      onPointerDown={onPointerDown}
      onClick={onClick}
    >
      Pause (30 Min)
    </div>
  )
}
